// Mock data for Waisted Bunny landing page

export const bunnyHeroData = {
  headline: "Fashion Meets Curves",
  subheadline: "Trendy, aesthetic shapewear designed for women who refuse to choose between style and confidence.",
  cta: "Shop The Collection"
};

export const bunnyAboutData = {
  headline: "About Waisted Bunny",
  story: "Waisted Bunny was created for the fashion-forward woman who lives for trends, aesthetics, and expressing herself boldly. We believe shapewear shouldn't be hidden—it should be a statement piece that makes you feel powerful and look incredible.",
  mission: "Our pieces blend cutting-edge design with premium performance. From bold prints to sleek neutrals, every Waisted Bunny piece is crafted to turn heads while giving you the support you deserve.",
  difference: "We're not just shapewear—we're a fashion movement. Style without sacrifice. Curves with confidence. That's the Waisted Bunny way."
};

export const bunnyProducts = [
  {
    id: 1,
    name: "Noir Sculpt Waist Trainer",
    description: "Sleek black design with gold hardware. Our bestselling waist trainer for the bold and confident.",
    benefits: ["Luxe matte finish", "Gold zipper detail", "All-day comfort", "Instant curves"],
    price: 54.99,
    tag: "BESTSELLER"
  },
  {
    id: 2,
    name: "Blush Babe Shaper",
    description: "Soft blush tones meet modern design. Perfect for layering or showing off.",
    benefits: ["Instagram-worthy", "Seamless design", "Breathable fabric", "Trend-forward"],
    price: 49.99,
    tag: "TRENDING"
  },
  {
    id: 3,
    name: "Leopard Luxe Trainer",
    description: "Make a statement with our signature leopard print waist trainer.",
    benefits: ["Bold print", "Fashion-forward", "Premium compression", "Statement piece"],
    price: 59.99,
    tag: "NEW"
  }
];

export const bunnyTestimonials = [
  {
    id: 1,
    name: "Alexa K.",
    location: "Miami",
    text: "Waisted Bunny is EVERYTHING. I get compliments every time I wear my leopard trainer to the gym. Style and support? Yes please!",
    rating: 5
  },
  {
    id: 2,
    name: "Zara L.",
    location: "Los Angeles",
    text: "Finally, shapewear that's actually cute! I love showing off my Waisted Bunny pieces. They're too good to hide under clothes.",
    rating: 5
  },
  {
    id: 3,
    name: "Nia T.",
    location: "Atlanta",
    text: "The quality is insane and the designs are so on-trend. Waisted Bunny gets it—fashion and function CAN coexist!",
    rating: 5
  }
];

export const bunnyPhilosophy = {
  headline: "Style + Confidence",
  message: "At Waisted Bunny, we believe your shapewear should be as bold and beautiful as you are. Why hide it when you can flaunt it?",
  values: [
    {
      title: "Fashion First",
      description: "Trend-driven designs that turn heads and make statements"
    },
    {
      title: "Confidence Always",
      description: "Feel powerful, look incredible, own every room you walk into"
    },
    {
      title: "Express Yourself",
      description: "Your style, your rules—we're just here to enhance your curves"
    },
    {
      title: "Quality Matters",
      description: "Premium materials meet cutting-edge design for pieces that last"
    }
  ]
};

export const bunnyFaqs = [
  {
    id: 1,
    question: "What makes Waisted Bunny different from other shapewear?",
    answer: "We're fashion-forward first! Our pieces are designed to be seen, not hidden. Bold prints, trendy colors, and aesthetic details set us apart from basic shapewear brands."
  },
  {
    id: 2,
    question: "Can I really wear these pieces as outerwear?",
    answer: "Absolutely! Many of our customers style our waist trainers with high-waisted jeans, skirts, or even as a top. Fashion has no rules—rock them however you feel confident!"
  },
  {
    id: 3,
    question: "How do I choose between Waisted Bunny and Waisted Momma?",
    answer: "Choose Waisted Bunny if you love bold fashion and trendy aesthetics. Choose Waisted Momma if you prefer classic, body-positive support. Both brands offer premium quality—just different vibes!"
  },
  {
    id: 4,
    question: "Do you release new prints and styles regularly?",
    answer: "Yes! We're constantly updating our collection with new prints, colors, and trend-inspired designs. Follow us on social media to see new drops first."
  },
  {
    id: 5,
    question: "Is the quality really as good as traditional shapewear?",
    answer: "Even better! We use premium compression fabrics, reinforced stitching, and durable hardware. You get fashion AND function—no compromises."
  },
  {
    id: 6,
    question: "What's your return policy?",
    answer: "We offer a 30-day return policy on unworn, unwashed items. We want you to love your Waisted Bunny piece—if it's not perfect, we'll make it right."
  }
];

export const bunnyFinalCTA = {
  headline: "Join The Bunny Movement",
  message: "Thousands of fashion-forward women are already rocking Waisted Bunny. It's time to elevate your style and confidence.",
  cta: "Shop Waisted Bunny Now"
};
